import SwiperSlider from "../components/abstract/SwiperSlider";
import $ from 'jquery'

export default class SliderTreElementi extends SwiperSlider {
 constructor(element, context) {
  super(element, context);
  $(() => {
   
   this.options = {
    initialSlide: this.element.data('last') ? this.element[0].querySelectorAll('.swiper-slide').length : 0,
    pagination: {
     el: this.element.find('.swiper-pagination')[0],
    },
    navigation: {
     nextEl: this.element.find('.swiper-button-next')[0],
     prevEl: this.element.find('.swiper-button-prev')[0],
    },
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
     1024: {
      slidesPerView: 2,
      spaceBetween: 30,
     },
     1224: {
      slidesPerView: 3,
      spaceBetween: 50,
     },
    },
    centeredSlides: false,
    loop: false,
   };

   $(() => {
    this.init()
   })
  });
 }
}